<div class="filter-modal">
    <div class="facs-filters-container">
      <div class='inner-container'>
        <div class="header">
          <div class="title">Filtros</div>
          <img class='close-btn' src="../../../../assets/svgs/close_btn.svg" alt="close" (click)="handleClose()">
        </div>
        <div>
          <div>
            <div class="time-row">  
              <p class="label">Data da criação</p>
              <div class="date">
                <div class="inputs-row" >
                  <nz-date-picker 
                    class="datepicker-input"
                    nzClassName="datepicker" 
                    nzDropdownClassName="datepicker-popup"
                    nzFormat="dd/MM/yyyy" 
                    nzPlaceHolder="- de" 
                    [(ngModel)]="createTime.date.from">
                  </nz-date-picker>
                  <app-timepicker
                    id='input-create-time-from'
                    [(ngModel)]="!createTime.date.from ? '' : createTime.hour.from" [disabled]="!createTime.date.from"
                    [placeholder]="'- de'" (selectValue)="createTime.hour.from = $event">
                  </app-timepicker>
                </div>
                <div class="inputs-row" >
                  <nz-date-picker 
                    class="datepicker-input"
                    nzClassName="datepicker" 
                    nzDropdownClassName="datepicker-popup"
                    nzFormat="dd/MM/yyyy" 
                    nzPlaceHolder="- até" 
                    [(ngModel)]="createTime.date.to">
                  </nz-date-picker>
                  <app-timepicker 
                    id='input-create-time-to'
                    [(ngModel)]="!createTime.date.to ? '' : createTime.hour.to" [disabled]="!createTime.date.to"
                    [placeholder]="'- até'" (selectValue)="createTime.hour.to = $event">
                  </app-timepicker>
                </div>
              </div>
            </div>
            <!-- Data e hora da distribuição -->
            <div class="time-row">  
              <p class="label">Data e hora da distribuição</p>
              <div class="date">          
                <div class="inputs-row" >
                  <nz-date-picker 
                    class="datepicker-input"
                    nzClassName="datepicker" 
                    nzDropdownClassName="datepicker-popup"
                    nzFormat="dd/MM/yyyy" 
                    nzPlaceHolder="- de" 
                    [(ngModel)]="distributionTime.date.from">
                  </nz-date-picker>
                  <app-timepicker 
                    id='input-distributed-time-from'
                    [(ngModel)]="!distributionTime.date.from ? '' : distributionTime.hour.from" [disabled]="!distributionTime.date.from"
                    [placeholder]="'- de'" (selectValue)="distributionTime.hour.from = $event">
                  </app-timepicker>
                </div>
                <div class="inputs-row" >
                  <nz-date-picker 
                    class="datepicker-input"
                    nzClassName="datepicker" 
                    nzDropdownClassName="datepicker-popup"
                    nzFormat="dd/MM/yyyy" 
                    nzPlaceHolder="- até" 
                    [(ngModel)]="distributionTime.date.to">
                  </nz-date-picker>
                  <app-timepicker 
                    id='input-distributed-time-to'
                    [(ngModel)]="!distributionTime.date.to ? '' : distributionTime.hour.to" [disabled]="!distributionTime.date.to" 
                    [placeholder]="'- até'" (selectValue)="distributionTime.hour.to = $event">
                  </app-timepicker>
                </div>
              </div>
            </div>
            <div class="pending__distribution" *ngIf="isStatusEnabled">
              <div class="input-title">Status</div>
              <div >
                <lib-input-checkbox name="distributionPending" label="Pendente da distribuição" [(ngModel)]="distributionPending">
                </lib-input-checkbox>
              </div>
            </div>
          </div>
          <hr class="horizontal-line" />
          <div class="distribution__filter__actions">
            <lib-button-tertiary (click)="resetForm()">Limpar tudo</lib-button-tertiary>
            <lib-button-primary (click)="sendFilter()">Aplicar</lib-button-primary>
          </div>
        </div>
      </div>
    </div>
  </div>